import { render, staticRenderFns } from "./insertFaq.vue?vue&type=template&id=19170944&"
import script from "./insertFaq.vue?vue&type=script&lang=js&"
export * from "./insertFaq.vue?vue&type=script&lang=js&"
import style0 from "./insertFaq.vue?vue&type=style&index=0&id=19170944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports